import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ThreeDots } from 'react-loader-spinner';
import { useAuth } from '../authProvider/AuthContext';
import AdminUsersTab from './AdminUsersTab';
import AdminCreditsTab from './AdminCreditsTab';
import AdminFeedbackTab from './AdminFeedbackTab';
import AdminAnalyticsTab from './AdminAnalyticsTab';
import './AdminPage.css';

const icons = {
    users: (
        <svg className="admin-nav-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    ),
    credits: (
        <svg className="admin-nav-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
            <rect x="2" y="6" width="20" height="12" rx="2" />
            <path d="M6 12h4M14 12h4M12 6v12" />
        </svg>
    ),
    feedback: (
        <svg className="admin-nav-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
    ),
    analytics: (
        <svg className="admin-nav-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
            <path d="M18 20V10M12 20V4M6 20v-6" />
        </svg>
    ),
};

const TABS = [
    { id: 'users', label: 'Users', icon: icons.users },
    { id: 'credits', label: 'Credits', icon: icons.credits },
    { id: 'feedback', label: 'Feedback', icon: icons.feedback },
    { id: 'analytics', label: 'Analytics', icon: icons.analytics },
];

const TAB_LABELS = {
    users: 'Directory and roles',
    credits: 'Balances and reservations',
    feedback: 'Inbound signals',
    analytics: 'Platform KPIs',
};

function AdminPage() {
    const { user, loading } = useAuth();
    const [activeTab, setActiveTab] = useState('users');

    if (loading) {
        return (
            <div className="admin-layout admin-layout--loading" aria-busy="true">
                <div className="admin-loader">
                    <ThreeDots color="#00BFFF" height={80} width={80} />
                </div>
            </div>
        );
    }

    if (!user?.isAdmin) {
        return <Navigate to="/" replace />;
    }

    const renderPanel = () => {
        switch (activeTab) {
            case 'users':
                return <AdminUsersTab />;
            case 'credits':
                return <AdminCreditsTab />;
            case 'feedback':
                return <AdminFeedbackTab />;
            case 'analytics':
                return <AdminAnalyticsTab />;
            default:
                return null;
        }
    };

    return (
        <div className="admin-layout">
            <nav className="admin-nav" aria-label="Admin sections">
                <div className="admin-nav-brand">
                    <span className="admin-nav-brand-mark" aria-hidden />
                    <span className="admin-nav-brand-text">Ops</span>
                </div>
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        type="button"
                        className={`admin-nav-item ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.icon}
                        <span className="admin-nav-label">{tab.label}</span>
                    </button>
                ))}
            </nav>
            <main className="admin-main">
                <div className="admin-main-inner">
                    <header className="admin-main-header">
                        <div>
                            <h1 className="admin-page-title">Admin</h1>
                            <p className="admin-page-subtitle">Platform operations</p>
                        </div>
                        <p className="admin-tab-hint" key={activeTab}>
                            {TAB_LABELS[activeTab]}
                        </p>
                    </header>
                    <div className="admin-panel-host" key={activeTab}>
                        {renderPanel()}
                    </div>
                </div>
            </main>
        </div>
    );
}

export default AdminPage;
